export default __webpack_public_path__ + "static/media/info.b4977728.svg";